import React, { useEffect, useMemo, useState } from "react";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import LayoutHOC from "../LayoutHOC";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import AddVendor from "./AddVendor";
import { useGetVendorHeadersQuery, useGetVendorHeadersValuesQuery } from "../../utils/customer/customerTaskTable";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Vendor = ({ addVendor, editVendor }) => {
  const [isAddVendorOpen, setIsVendorOpen] = useState(false);
  const [activeNavTab, setActiveNavTab] = useState("vendors");
  const [selectedVendorData, setSelectedVendorData] = useState(null);
  const [isEditVendor, setIsEditVendor] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [vendorName, setVendorName] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const vendorData = location?.state?.vendorData;

  console.log(vendorName, "vendorName84867874");

  useEffect(() => {
    if (editVendor && vendorData) {
      setIsEditVendor(true);
      setSelectedVendorData(vendorData);
      setIsVendorOpen(true);
      setVendorName(vendorData?.vendor_name || "");
    } else if (addVendor) {
      setIsVendorOpen(true);
      setSelectedVendorData(null);
      setIsEditVendor(false);
      setVendorName(""); // Initialize as empty, will be set by VendorGeneralInfo via API
      setIsDisable(false);
    } else {
      setSelectedVendorData(null);
      setIsDisable(false);
      setIsVendorOpen(false);
      setIsEditVendor(false);
      setVendorName("");
    }
  }, [vendorData, addVendor, editVendor]);

  const SummaryCard = ({ icon, amount, label, bgColor, iconBg }) => {
    return (
      <div className={`rounded-md p-4 ${bgColor} flex items-center gap-4 shadow-sm`}>
        <div className={`w-10 h-10 flex items-center justify-center rounded-full text-white text-lg ${iconBg}`}>
          {icon}
        </div>
        <div>
          <p className="text-16 text-[#2C495D] font-600">{amount}</p>
          <p className="text-12 font-400 text-[#5E5E5E] whitespace-nowrap">{label}</p>
        </div>
      </div>
    );
  };

  const boxData = [
    {
      icon: "🧾",
      amount: "$ 0.00",
      label: "0 Estimates",
      bgColor: "bg-blue-100",
      iconBg: "bg-blue-500",
    },
    {
      icon: "📄",
      amount: "$ 0.00",
      label: "Unbilled Income",
      bgColor: "bg-purple-100",
      iconBg: "bg-purple-500",
    },
    {
      icon: "🔁",
      amount: "$ 0.00",
      label: "1 Overdue Invoices",
      bgColor: "bg-orange-100",
      iconBg: "bg-orange-500",
    },
    {
      icon: "✉️",
      amount: "$ 0.00",
      label: "1 Open Invoice Or Credit",
      bgColor: "bg-gray-100",
      iconBg: "bg-gray-400",
    },
    {
      icon: "💰",
      amount: "$ 0.00",
      label: "Unbilled Income",
      bgColor: "bg-green-100",
      iconBg: "bg-green-500",
    },
  ];

  function DebouncedInput({ value: initialValue, onChange, debounce = 200, ...props }) {
    const [value, setValue] = React.useState(initialValue);

    React.useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);

    React.useEffect(() => {
      const timeout = setTimeout(() => {
        onChange(value);
      }, debounce);

      return () => clearTimeout(timeout);
    }, [value, debounce, onChange]);

    return (
      <input
        {...props}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="text-black text-xs border-none bg-white p-3 border-gray-600 shadow rounded focus:outline-none focus:ring-0"
      />
    );
  }

  const handleAddVendor = () => {
    navigate("/add-vendor", {
      state: {
        isViewMode: false,
        isEditMode: false,
      },
    });
  };

  const handleCloseVendor = () => {
    setIsVendorOpen(false);
    setSelectedVendorData(null);
    setIsEditVendor(false);
    setIsDisable(false);
    setVendorName("");
    navigate("/vendors");
  };

  const handleOpenVendor = (vendorRow) => {
    navigate(`/vendor-profile/${vendorRow.row_id}`, {
      state: {
        isEditMode: true,
      },
    });
  };

  const navBarItems = [
    { key: "expenses", label: "Expenses" },
    { key: "bills", label: "Bills" },
    { key: "purchaseOrders", label: "Purchase Orders" },
    { key: "billPayments", label: "Bill Payments" },
    { key: "vendors", label: "Vendors" },
  ];

  const {
    data: vendorHeader,
    isLoading: isVendorHeaderLoading,
    isFetching: isVendorHeaderFetching,
    isSuccess: isVendorHeaderSuccess,
    isError: isVendorHeaderError,
    refetch: refetchVendorHeader,
  } = useGetVendorHeadersQuery();

  const {
    data: vendorValues,
    isLoading: isVendorValuesLoading,
    isFetching: isVendorValuesFetching,
    isSuccess: isVendorValuesSuccess,
    isError: isVendorValuesError,
    refetch: refetchVendorValues,
  } = useGetVendorHeadersValuesQuery();

  const allowedKeys = ["vendor_name", "business_category", "phone", "email", "website"];

  const headerOrder = [...allowedKeys];

  const filteredHeaders = useMemo(() => {
    if (!vendorHeader?.data) {
      dispatch(pushAlert({ message: "Values Not Found", type: "error", visible: true }));
      return [];
    }

    const headersWithRank = vendorHeader.data
      .filter((header) => allowedKeys.includes(header.value))
      .map((header) => ({
        ...header,
        rank: headerOrder.indexOf(header.value) !== -1 ? headerOrder.indexOf(header.value) : 999,
      }))
      .sort((a, b) => a.rank - b.rank)
      .map((header) => ({
        accessor_key: header.value,
        label: header.label || header.value.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
        ...(header.value === "vendor_name" && {
          callingFunction: handleOpenVendor,
        }),
        className: header.value === "vendor_name" ? "text-blue-700 cursor-pointer underline" : "",
      }));

    return [
      ...headersWithRank,
      {
        accessor_key: "action",
        label: "Action",
        cellRenderer: (rowData) => (
          <select className="border px-2 py-1 rounded text-sm bg-white">
            <option>Create Expense</option>
            <option>Send Email</option>
            <option>Delete</option>
          </select>
        ),
      },
    ];
  }, [vendorHeader, vendorValues]);

  const finalBody = useMemo(() => {
    if (!vendorValues?.data) return [];

    return vendorValues.data.map((row) => {
      const formattedRow = { row_id: row.row_id };

      allowedKeys.forEach((key) => {
        const value = row.data?.[key]?.value || "";
        formattedRow[key] = typeof value === "string" ? value.charAt(0).toUpperCase() + value.slice(1) : value;
      });

      return formattedRow;
    });
  }, [vendorValues]);

  return (
    <>
      {!isAddVendorOpen ? (
        <div className="h-full flex flex-col">
          <div className="h-fit">
            <ul className="flex space-x-4 ps-2 border-b border-[#D2DAE1] bg-white pt-2">
              {navBarItems.map((item) => (
                <li
                  key={item.key}
                  onClick={() => setActiveNavTab(item.key)}
                  className={`p-2 cursor-pointer relative 
        ${activeNavTab === item.key ? "text-[#1D4469] font-600 text-14" : "text-[#888] text-14 font-500"} 
        hover:bg-gray-100`}
                >
                  <span>{item.label}</span>
                  {activeNavTab === item.key && (
                    <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#1D4469] rounded-t-md"></div>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className="h-fit">
            {false && (
              <div className="flex justify-between items-center p-4 bg-white shadow-md h-fit">
                <h3 className="text-[#383838] text-18 font-600">Vendors</h3>
                <DebouncedInput
                  type="text"
                  value={""}
                  onChange={() => {}}
                  placeholder={`Search`}
                  className="w-24 border-gray-300 bg-gray-300 shadow rounded"
                />
              </div>
            )}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 bg-gray-100 p-4 w-full h-fit">
              {boxData.map((box, index) => (
                <SummaryCard key={index} {...box} />
              ))}
            </div>
          </div>
          <div className="p-4 grow min-h-0 h-full">
            <ReactTableComponent
              // tablename={<span>Vendor Dashboard </span>}
              headers={filteredHeaders}
              body={finalBody}
              actionField={
                <div className="flex items-center gap-2">
                  <Link
                    to="/add-vendor"
                    state={{
                      isViewMode: false,
                      isEditMode: false, // Disable sidebar for Add Vendor
                    }}
                    onClick={handleAddVendor}
                  >
                    <PlusIcon isActive={""} />
                  </Link>
                </div>
              }
            />
          </div>
        </div>
      ) : (
        <div className="w-full bg-white relative h-full">
          <AddVendor
            handleCloseVendor={handleCloseVendor}
            editData={selectedVendorData}
            isEditVendor={isEditVendor}
            setIsEditVendor={setIsEditVendor}
            refetchVendorHeader={refetchVendorHeader}
            refetchVendorValues={refetchVendorValues}
            isDisable={isDisable}
            setIsDisable={setIsDisable}
            vendorName={vendorName}
            setVendorName={setVendorName}
            setSelectedVendorData={setSelectedVendorData}
          />
        </div>
      )}
    </>
  );
};

export default LayoutHOC(Vendor);
